import DefaultService from "../services/screens/DefaultService";
import RegionServerManager from "./RegionServerManager";

function addError(inVO, successCallback, failureCallback) {
    let manager = RegionServerManager.instance();
    let server = manager.getSelectedServer();
    if (server) {
        if (inVO.errorTrace) {
            inVO.errorTrace = server.name + ':' + server.region + '\n' + inVO.errorTrace;
        }
        else {
            inVO.errorTrace = server.name + ':' + server.region;
        }
    }

    DefaultService.addErrorData(
        inVO,
        response => {
            // if (successCallback) successCallback();
        },
        error => {
            //console.log("err", error);
            // if (failureCallback) failureCallback();
        }
    );
}

export {
   addError
};
